module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "bg",
    class: _vm.getColorClass(_vm.event.tid, _vm.event.parents_id),
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.event.longtitle))]), _vm._v(" "), (_vm.showTime) ? _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.event.datetime))]) : _vm._e()]), _vm._v(" "), (_vm.isClicked) ? _c('EventHover', {
    attrs: {
      "event": _vm.event
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-453a262a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/OneEvent.vue
// module id = 564
// module chunks = 1